webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = uuid;
function imageUrl(url) {
  return 'https://s3.eu-central-1.amazonaws.com/www.bendpanic.com/projects/' + url;
}

function uuid() {
  var uuid = '';
  var ii = void 0;
  for (ii = 0; ii < 32; ii += 1) {
    switch (ii) {
      case 8:
      case 20:
        uuid += '-';
        uuid += (Math.random() * 16 | 0).toString(16);
        break;
      case 12:
        uuid += '-';
        uuid += '4';
        break;
      case 16:
        uuid += '-';
        uuid += (Math.random() * 4 | 8).toString(16);
        break;
      default:
        uuid += (Math.random() * 16 | 0).toString(16);
    }
  }
  return uuid;
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WIP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ILLUSTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMICS; });
/* unused harmony export OBJECTS */
var WIP = {
  id: 0,
  name: 'wip'
};
var ANIMATION = {
  id: 1,
  name: 'animation'
};
var ILLUSTRATION = {
  id: 2,
  name: 'illustration'
};
var COMICS = {
  id: 3,
  name: 'comics'
};
var OBJECTS = {
  id: 4,
  name: 'objects'
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Projects__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Project__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NotFound__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NotFound__);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_4__components_About___default.a
  }, {
    path: '/:category?',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Projects___default.a
  }, {
    path: '/project/:project',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Project___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_5__components_NotFound___default.a
  }]
}));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects__ = __webpack_require__(39);






__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var categories = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */]).reduce(function (p, curr) {
  return p.concat(__WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */][curr].categories);
}, []).filter(function (v, i, a) {
  return a.indexOf(v) === i;
});

var state = {
  categories: categories,
  projects: __WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */],
  featured: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */]).find(function (id) {
    return __WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */][id].name === 'Love Me, Fear Me';
  })
};

function prioritySort(pA, pB) {
  var priA = pA.priority || 0;
  var priB = pB.priority || 0;

  return priA - priB;
}

function categoryFilter(category) {
  return function (project) {
    return category ? project.categories.find(function (c) {
      return c.name.match(category);
    }) : true;
  };
}

function projectNameFilter(projectName) {
  return function (project) {
    return projectName && project.name.match(projectName);
  };
}

function getProjects(state) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.projects).map(function (p) {
    return state.projects[p];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  getters: {
    email: function email() {
      return 'veronica@bendpanic.com';
    },
    categories: function categories(state) {
      return state.categories.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    projects: function projects(state) {
      return getProjects(state).filter(categoryFilter(state.route.params.category)).sort(prioritySort);
    },
    selectedProject: function selectedProject(state) {
      return getProjects(state).filter(projectNameFilter(state.route.params.project))[0];
    },
    featured: function featured(state) {
      return state.featured && state.projects[state.featured];
    }
  },
  mutations: {},
  actions: {}
}));

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_index_scss__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_index_scss__);











__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 1,
  name: '3rd Date',
  thumbnail: './3rdDate/3rdDate_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/243323371']
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Awkward',
  thumbnail: './Awkward/Awk_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Awkward/Angels.jpg', './Awkward/Berries-dark.jpg', './Awkward/Birds.jpg', './Awkward/Clouder.jpg', './Awkward/Eggs.jpg', './Awkward/Faces.jpg', './Awkward/Fairytale.jpg', './Awkward/Fruhstuck.jpg', './Awkward/Hipsters.jpg', './Awkward/Oldies.jpg', './Awkward/OpiumScene.jpg', './Awkward/Scene04.jpg', './Awkward/Scene12.jpg', './Awkward/Scene14.jpg', './Awkward/TheTeaParty.jpg']
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 7,
  name: 'Backgrounds',
  thumbnail: './Backgrounds/Bkg_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Backgrounds/LS_gradina.jpg', './Backgrounds/LS_nterior.jpg', './Backgrounds/LS_Dormitor.jpg', './Backgrounds/LS_drum_asfintit.jpg', './Backgrounds/LS_Sat_pan1.jpg', './Backgrounds/LS_SAt_pan2.jpg', './Backgrounds/FiareVechi.jpg', './Backgrounds/dupa-bloc.jpg', './Backgrounds/BdUnirii.jpg', './Backgrounds/pta-Rev.jpg', './Backgrounds/moto-gunoi.jpg', './Backgrounds/AP_Est_Duel1.jpg', './Backgrounds/AP_Oz_lan.jpg', './Backgrounds/Basferatu_Gradina.jpg', './Backgrounds/Wudang.jpg', './Backgrounds/Hotel.jpg', './Backgrounds/Basferatu_SediuConsp.jpg', './Backgrounds/Interior_intreg.jpg', './Backgrounds/masa_de_lucru.jpg', './Backgrounds/compoz.Lat.jpg', './Backgrounds/Vehicle_views.jpg', './Backgrounds/Vehicles.jpg', './Backgrounds/Planes.jpg', './Backgrounds/Masini3.jpg', './Backgrounds/locomotiva1.jpg']
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Inglorious Pirates',
  thumbnail: './Berta/Berta.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/224752586']
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 3,
  name: 'Through Bucharest',
  thumbnail: './Bucharest/Comic_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["c" /* COMICS */]],
  content: ['./Bucharest/Comic1-mic.jpg', './Bucharest/Comic2-mic.jpg', './Bucharest/Comic3-mic.jpg', './Bucharest/Comic4-mic.jpg']
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Carry On',
  thumbnail: './CarryOn/Carry-On_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/129639959']
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Cleaning Day',
  thumbnail: './CleaningDay/C-Day_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/135044087']
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 3,
  name: 'Colour Pictures',
  thumbnail: './ColourPictures/00_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["c" /* COMICS */]],
  content: ['./ColourPictures/01-title.jpg', './ColourPictures/02.jpg', './ColourPictures/03.jpg', './ColourPictures/04.jpg']
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 3,
  name: 'Cordiceps',
  thumbnail: './Cordiceps/Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Cordiceps/Distopia-det02.jpg', './Cordiceps/Distopia-det3.jpg', './Cordiceps/Distopia-det4.jpg', './Cordiceps/euro-det3.jpg', './Cordiceps/euro-det6.jpg', './Cordiceps/euro-mic.jpg']
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 1,
  name: 'Crayons',
  thumbnail: './Crayons/01_Crayons-Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['Crayons/Auntie.jpg', 'Crayons/Backride copy.jpg', 'Crayons/Bath copy.jpg', 'Crayons/Batman.jpg', 'Crayons/Boys.jpg', 'Crayons/Dad-read_orange.jpg', 'Crayons/Ent_Peacock.jpg', 'Crayons/Ent_Peacock_det.jpg', 'Crayons/Fishees.jpg', 'Crayons/Giant-crash.jpg', 'Crayons/Giant-croc.jpg', 'Crayons/Giant_sleep_HDR.jpg', 'Crayons/Giant_sleep_HDR_det01.jpg', 'Crayons/Kaidan.jpg', 'Crayons/reading.jpg', 'Crayons/reading_det.jpg', 'Crayons/Red_Cat.jpg', 'Crayons/Red_Cat_Det2.jpg', 'Crayons/Street.jpg', 'Crayons/Tanzen2.jpg', 'Crayons/twoCircus.jpg', 'Crayons/twoCircus_det2.jpg']
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 3,
  name: 'Editorials',
  thumbnail: './Editorials/Edit-Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Editorials/End_ofthe_World.jpg', './Editorials/Play.jpg', './Editorials/Soros-Tree.jpg', './Editorials/Soros-Detail.jpg', './Editorials/Tatal.jpg', './Editorials/Babuin.jpg', './Editorials/Coperta_int_play.jpg', './Editorials/DOR4-a.jpg', './Editorials/DOR4-b.jpg', './Editorials/PointofNo.jpg', './Editorials/Porcu.jpg', './Editorials/Technophilia.jpg', './Editorials/DarkWindow.jpg', './Editorials/IlustratieCoperta.jpg', './Editorials/Tierkonferenz.jpg', './Editorials/parade.jpg']
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 5,
  name: 'Ein dunkles Fenster',
  thumbnail: './EindunklesFenster/GrafNovel_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["c" /* COMICS */]],
  content: ['./EindunklesFenster/Cover.jpg', './EindunklesFenster/GrafNovel01.jpg', './EindunklesFenster/GrafNovel02.jpg', './EindunklesFenster/Graf.Nov03.jpg', './EindunklesFenster/grafNov04.jpg']
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'George’s Superpowers',
  thumbnail: './George/A5George_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["c" /* COMICS */]],
  content: ['./George/A5George1.jpg', './George/A5George2.jpg', './George/A5George3.jpg', './George/A5George4.jpg', './George/A5George5.jpg', './George/A5George6.jpg', './George/A5George7.jpg', './George/A5George8.jpg']
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Grandma 13',
  thumbnail: './Grandma/a5_jamThumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["c" /* COMICS */]],
  content: ['./Grandma/a5-jam1.jpg', './Grandma/A5-jam2.jpg', './Grandma/A5-jam3.jpg', './Grandma/A5-jam4.jpg']
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'How to Deal with Nonsense',
  thumbnail: './HTDWN/HTDWN-Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/22624346']
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3rddate__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__awkward__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backgrounds__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__berta__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bucharest__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__carryon__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cleaningday__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cordiceps__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colourpictures__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editorials__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__eindunklesfenster__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__grandma__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__george__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__htdwn__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lmfm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loops__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__notld__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scarytales__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__storms__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__storyboards__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__crayons__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tuutuutil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__skandaloes__ = __webpack_require__(44);


var _TuuTuuTil$id$Skandal;

























/* harmony default export */ __webpack_exports__["a"] = (_TuuTuuTil$id$Skandal = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_22__tuutuutil__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_22__tuutuutil__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_23__skandaloes__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_23__skandaloes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_1__3rddate__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_1__3rddate__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_2__awkward__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_2__awkward__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_3__backgrounds__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_3__backgrounds__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_4__berta__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_4__berta__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_5__bucharest__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_5__bucharest__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_6__carryon__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_6__carryon__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_7__cleaningday__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_7__cleaningday__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_8__cordiceps__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_8__cordiceps__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_9__colourpictures__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_9__colourpictures__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_10__editorials__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_10__editorials__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_11__eindunklesfenster__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_11__eindunklesfenster__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_12__grandma__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_12__grandma__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_13__george__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_13__george__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_14__htdwn__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_14__htdwn__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_15__lmfm__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_15__lmfm__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_16__loops__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_16__loops__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_17__notld__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_17__notld__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_18__scarytales__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_18__scarytales__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_19__storms__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_19__storms__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_20__storyboards__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_20__storyboards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TuuTuuTil$id$Skandal, __WEBPACK_IMPORTED_MODULE_21__crayons__["a" /* default */].id, __WEBPACK_IMPORTED_MODULE_21__crayons__["a" /* default */]), _TuuTuuTil$id$Skandal);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 0,
  name: 'Love Me, Fear Me',
  thumbnail: './LMFM/LMFM-Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/448617702', 'https://vimeo.com/454693987', './LMFM/Fool_loop.gif', './LMFM/Rebirth.gif']
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 1,
  name: 'Loops',
  thumbnail: './Loops/Loops_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/865327122', 'https://vimeo.com/865325257', 'https://vimeo.com/865322824', 'https://vimeo.com/234725615', 'https://vimeo.com/210048163', 'https://vimeo.com/184188892', 'https://vimeo.com/174807224', 'https://vimeo.com/81565710', 'https://vimeo.com/9946244']
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Night of the Leaving Dreads',
  thumbnail: './NOTLD/NOTLD_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/345640689']
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 5,
  name: 'Scarrytales',
  thumbnail: './Scarrytales/Carn_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Scarrytales/Carnival-detail01.jpg', './Scarrytales/Carnival-detail02.jpg', './Scarrytales/Carnival.jpg']
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 1,
  name: 'Skandalös Festival trailer',
  thumbnail: './Skandaloes/Skandaloes.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/712014507']
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 2,
  name: 'Storms',
  thumbnail: './Storms/Storms_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Storms/Storm-beach.jpg', './Storms/Storm03.jpg', './Storms/Storm01.jpg', './Storms/Nosebleed.jpg', './Storms/Kometfresser.jpg', './Storms/Bear-feel.jpg', './Storms/Titaninen.jpg']
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 6,
  name: 'Storyboards',
  thumbnail: './Storyboards/Stb_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["a" /* ILLUSTRATION */]],
  content: ['./Storyboards/Lesara-3X.jpg', './Storyboards/FlightRight.jpg', './Storyboards/NieseTrailer.jpg', './Storyboards/Outfittery.jpg', './Storyboards/UPSwords.jpg']
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* uuid */])(),
  priority: 1,
  name: 'TUU TUU TIL',
  thumbnail: './TuuTuuTil/TTT_Thumb.jpg',
  categories: [__WEBPACK_IMPORTED_MODULE_1__categories__["b" /* ANIMATION */]],
  content: ['https://vimeo.com/909724609', './TuuTuuTil/TTT-still01.jpg', './TuuTuuTil/TTT-still02.jpg', './TuuTuuTil/TTT-still03.jpg']
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuBar__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MenuBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Categories__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Categories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Foot__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Foot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Foot__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    MenuBar: __WEBPACK_IMPORTED_MODULE_0__components_MenuBar___default.a,
    Categories: __WEBPACK_IMPORTED_MODULE_1__components_Categories___default.a,
    Foot: __WEBPACK_IMPORTED_MODULE_2__components_Foot___default.a
  },
  computed: {
    projects: function projects() {
      return this.$store.getters.projects;
    },
    categories: function categories() {
      return this.$store.getters.categories;
    },
    selectedProject: function selectedProject() {
      return this.$store.getters.selectedProject;
    }
  },
  methods: {
    clearFilters: function clearFilters() {
      this.setProject(null);
      this.setCategory(null);
    },
    setProject: function setProject(project) {
      this.$store.dispatch('setProject', project);
    },
    setCategory: function setCategory(category) {
      this.$store.dispatch('setCategory', category);
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  components: {},
  data: function data() {
    var email = this.$store.getters.email;

    return {
      contacts: [{
        name: 'e-mail',
        href: 'mailto:' + email
      }, {
        name: 'linkedin',
        href: 'https://www.linkedin.com/company/bendpanic-production'
      }, {
        name: 'instagram',
        href: 'https://www.instagram.com/bendpanic/'
      }, {
        name: 'facebook',
        href: 'https://www.facebook.com/bendpanic'
      }],
      clients: ['Green Peace', 'Wolkenlenker', 'Nexus Studios', 'Cake FX', 'NRDC', 'Arte Deutschland', 'MobyDok', 'DCMN', 'Climate Media Factory', 'FAB Berlin', 'IraRu Films', 'Clay Traces', 'Talking Animals', 'Arte', 'DeFilm', 'Castel Film']
    };
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'categories',
  props: ['categories']
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foot',
  computed: {
    email: function email() {
      return 'mailto:' + this.$store.getters.email;
    },
    year: function year() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu-bar',
  data: function data() {
    return {
      menuOpen: false
    };
  },

  computed: {
    menuClass: function menuClass() {
      var open = this.menuOpen ? 'open' : 'closed';
      return '' + open;
    },
    hamburgerClass: function hamburgerClass() {
      return this.menuOpen ? 'is-active' : '';
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.setMenuState(!this.menuOpen);
    },
    setMenuState: function setMenuState(state) {
      this.menuOpen = state;
    }
  },
  watch: {
    '$route': function $route() {
      this.setMenuState(false);
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectBanner__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProjectBanner__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'more-projects',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ProjectBanner: __WEBPACK_IMPORTED_MODULE_0__ProjectBanner___default.a
  },
  computed: {
    categories: function categories() {
      var categories = this.$props.project.categories.map(function (c) {
        return c.name;
      }).join(', ');

      return categories;
    },
    projects: function projects() {
      var _this = this;

      var projects = this.$props.project.categories.map(function (c) {
        return _this.$store.getters.projects.filter(function (p) {
          return p.categories.find(function (cd) {
            return cd.id === c.id;
          });
        });
      })[0].filter(function (p) {
        return p.id !== _this.$props.project.id;
      });

      return projects;
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-found',
  components: {},
  methods: {},
  computed: {}
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VimeoEmbed__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VimeoEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VimeoEmbed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MoreProjects__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MoreProjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MoreProjects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  components: {
    VimeoEmbed: __WEBPACK_IMPORTED_MODULE_0__VimeoEmbed___default.a,
    MoreProjects: __WEBPACK_IMPORTED_MODULE_1__MoreProjects___default.a
  },
  methods: {
    isImage: function isImage(content) {
      return content.match(/\.(png|jpe?g|gif|svg)(\?.*)?$/);
    },
    isVimeo: function isVimeo(content) {
      return content.match(/vimeo/);
    },
    imagePath: function imagePath(image) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* imageUrl */])(image);
    }
  },
  computed: {
    project: function project() {
      if (this.$store.getters.selectedProject) {
        return this.$store.getters.selectedProject;
      } else {
        this.$router.push('/');
        return {};
      }
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-banner',
  props: ['project'],
  computed: {
    projectPath: function projectPath() {
      return '/project/' + this.$props.project.name;
    }
  },
  methods: {
    imagePath: function imagePath() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* imageUrl */])(this.$props.project.thumbnail);
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectBanner__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProjectBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VimeoEmbed__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VimeoEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VimeoEmbed__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  components: {
    ProjectBanner: __WEBPACK_IMPORTED_MODULE_0__ProjectBanner___default.a,
    VimeoEmbed: __WEBPACK_IMPORTED_MODULE_1__VimeoEmbed___default.a
  },
  methods: {
    isVimeo: function isVimeo(content) {
      return content.match(/vimeo/);
    }
  },
  computed: {
    featured: function featured() {
      return !this.$route.params.category && this.$store.getters.featured;
    },
    projects: function projects() {
      var _this = this;

      try {
        if (this.$store.getters.projects.length === 0) {
          this.$router.push('/');
        }

        return this.$route.params.category ? this.$store.getters.projects : this.$store.getters.projects.filter(function (p) {
          return p.id !== _this.$store.state.featured;
        });
      } catch (e) {
        this.$router.push('/');
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


function fetchIframe(url) {
  var apiParams = 'color=ea445b';
  var apiURL = 'https://vimeo.com/api/oembed.json?url=' + url + '&' + apiParams;

  return window.fetch(apiURL).then(function (r) {
    return r.json();
  }).then(function (result) {
    return result.html;
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vimeo-embed',
  props: ['url'],
  data: function data() {
    return {
      iframe: ''
    };
  },
  created: function created() {
    var _this = this;

    var url = this.$props.url;


    fetchIframe(url).then(function (iframe) {
      _this.iframe = iframe;
    });
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h2', [_vm._v("404")])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_c('span', [_vm._v("©")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.email
    }
  }, [_vm._v("Veronica Solomon")]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(_vm.year))])])])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-bar",
    class: _vm.menuClass
  }, [_c('button', {
    staticClass: "menu-bar__hamburger",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "hamburger hamburger--elastic",
    class: _vm.hamburgerClass
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-bar__title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-bar__menu"
  }, [_vm._t("categories")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hamburger-box"
  }, [_c('div', {
    staticClass: "hamburger-inner"
  })])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page projects"
  }, [(_vm.featured) ? _c('div', {
    staticClass: "projects__featured"
  }, [(_vm.isVimeo(_vm.featured.content[0])) ? _c('vimeo-embed', {
    attrs: {
      "url": _vm.featured.content[0]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "project-item",
      "tag": "div"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "project-item"
    }, [_c('project-banner', {
      attrs: {
        "project": project
      }
    })], 1)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "project-banner",
    attrs: {
      "to": {
        path: _vm.projectPath
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePath()
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.project.name))])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vimeo",
    domProps: {
      "innerHTML": _vm._s(_vm.iframe)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, [_vm._l((_vm.categories), function(category) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": '/' + category.name
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  }), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page project"
  }, [_c('h2', [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('ul', _vm._l((_vm.project.content), function(content) {
    return _c('li', [(_vm.isVimeo(content)) ? _c('vimeo-embed', {
      key: content,
      attrs: {
        "url": content
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isImage(content)) ? _c('img', {
      key: content,
      attrs: {
        "src": _vm.imagePath(content)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isImage(content) && !_vm.isVimeo(content)) ? _c('p', {
      key: content
    }, [_vm._v("\n        " + _vm._s(content) + "\n      ")]) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('more-projects', {
    attrs: {
      "project": _vm.project
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-projects"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("More " + _vm._s(_vm.categories))]), _vm._v(" "), _c('div', {
    staticClass: "projects-container"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "project-item"
    }, [_c('project-banner', {
      attrs: {
        "project": project
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('menu-bar', [_c('router-link', {
    attrs: {
      "slot": "title",
      "to": "/"
    },
    slot: "title"
  }, [_c('h1', [_vm._v("Bendpanic")]), _vm._v(" "), _c('h2', {
    staticClass: "subheader"
  }, [_vm._v("Production")])]), _vm._v(" "), _c('categories', {
    attrs: {
      "slot": "categories",
      "categories": _vm.categories
    },
    slot: "categories"
  })], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page contact"
  }, [_c('div', {
    staticClass: "me"
  }, [_c('img', {
    staticClass: "me__pic",
    attrs: {
      "src": "/static/logo_wide.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "me__description"
  }, [_c('p', [_vm._v("\n          Bendpanic Production is a creative studio specialised in stop-motion and 2D animation run by director and visual artist Veronica Solomon. We work on bring ideas to life in charming and inspiring narratives connecting with the audience through meaning, emotions and original content with a focus on character driven storytelling.\nBased in Tampere - Finland, active worldwide.\n\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Our creative process draws on over 20 years of experience in artistic creation and animation production. We support our in-house animation services with a network of trusted and highly capable collaborators. Our portfolio includes a selection of original productions and commissioned works that best reflects our variety of style and techniques.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lists"
  }, [_c('div', {
    staticClass: "clients"
  }, [_c('h3', [_vm._v("Clients")]), _vm._v(" "), _c('ul', _vm._l((_vm.clients), function(client) {
    return _c('li', [_vm._v("\n                " + _vm._s(client) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('ul', _vm._l((_vm.contacts), function(contact) {
    return _c('li', [_c('a', {
      attrs: {
        "href": contact.href,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(contact.name) + "\n                ")])])
  }), 0)])])])])])
},staticRenderFns: []}

/***/ })
],[23]);


// WEBPACK FOOTER //
// static/js/app.abc0eeba50563d2019b4.js